import getConfig from 'next/config';

export type PublicConfigVars = {
  BASE_URL: string;
  GRAPHQL_SERVER_EXTERNAL: string;
  IDP_ENDPOINT: string;
  IDP_CLIENT_ID_INTERACTIVE: string;
  LOG_LEVEL: string;
  VIDEOJS_LOG_LEVEL: 'debug' | 'info' | 'warn' | 'error' | 'off';
  NOTIFICATIONS_ENDPOINT: string;
  ENABLE_NEXT_EPISODE_BUTTON: string;
  ENABLE_PLAYER_V2: string;
  CAPTCHA_SITE_KEY: string;
  CAPTCHA_API_URL: string;
  DRM_LICENSE_SERVER_URL: string;
  PREVIEW_URL_SECRET_KEY: string;
  ENV: string;
  VERSION: string;
};

type PublicConfigVar = keyof PublicConfigVars;

/**
 * make next env vars accessible in a save way for all environments including server and storybook as well.
 * You can also provide default values, if those values are present in the environment it will return those instead
 * of the default value.
 *
 * Example:
 * const {SOME_ENV_VAR} = getConfigVars({SOME_ENV_VAR: 'defaultValue'});
 *
 */

function getConfigVars<T extends Partial<PublicConfigVars>>(
  defaultVars?: T
): T {
  const config = getConfig();
  const runtimeConfig = config?.publicRuntimeConfig;
  if (!runtimeConfig && defaultVars) {
    return defaultVars;
  }

  //override default vars with runtime vars
  if (defaultVars) {
    Object.entries(defaultVars).forEach(([key, value]) => {
      defaultVars[key as PublicConfigVar] = runtimeConfig[key] || value;
    });
  }

  return defaultVars || runtimeConfig;
}

export default getConfigVars;
